import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameList = _resolveComponent("GameList")!
  const _component_GameLoader = _resolveComponent("GameLoader")!
  const _component_UserArea = _resolveComponent("UserArea")!

  return (_openBlock(), _createBlock(_component_UserArea, {
    subject: "maths",
    private: !_ctx.isMathsframe
  }, {
    default: _withCtx(() => [
      (_ctx.level || _ctx.customLevel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.levelName), 1),
            (_ctx.customLevel)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.levelDeadline), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_GameList, {
              games: _ctx.games,
              onSelectgame: _ctx.onPlayGame
            }, null, 8, ["games", "onSelectgame"]),
            _createVNode(_component_GameLoader, {
              game: _ctx.currentGame,
              "maths-level": _ctx.level,
              "maths-custom-level": _ctx.customLevel,
              onClosegame: _ctx.onCloseGame
            }, null, 8, ["game", "maths-level", "maths-custom-level", "onClosegame"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["private"]))
}